
export const ellipsisMiddle = (text, limit=18) => {
    if (!text || text.length <= limit) {
        return text;
    }

    return (
        text.substring(0, Math.floor(limit / 2)) + "..." +
        text.substring(text.length - Math.ceil(limit / 2))
    )
};
